import { useEffect, useState } from 'preact/hooks'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'

function useProductVariant ({ variants, options, updateCurrentVariant, currentVariant, updateUrl }) {
  const [selected, setSelected] = useState({})
  const [selectableValues, setSelectableValues] = useState({})

  const getSelectableValues = (a, b) => {
    const values = Object.assign({}, a)
    const selectedOptions = Object.keys(b)
    if (!selectedOptions.length) {
      return values
    }
    for (const selectedOption of selectedOptions) {
      const selectedValue = b[selectedOption]
      const otherOptions = options.filter((option) => option !== selectedOption)
      if (otherOptions.length) {
        for (const otherOption of otherOptions) {
          values[otherOption] = values[otherOption].filter((value) => {
            return variants.some((variant) => variant.options.indexOf(value) !== -1 && variant.options.indexOf(selectedValue) !== -1 && variant.available)
          })
        }
      } else {
        values[selectedOption] = values[selectedOption].filter((value) => {
          if (options.length > 1) {
            return variants.some((variant) => variant.options.indexOf(value) !== -1 && variant.options.indexOf(selectedValue) !== -1 && variant.available)
          } else {
            return variants.some((variant) => variant.options.indexOf(selectedValue) !== -1 && variant.available)
          }
        })
      }
    }
    return values
  }

  const getSelectedVariant = (selectedValues) => {
    const matched = variants.filter((variant) => {
      const matchedOptions = []
      for (const option in selectedValues) {
        matchedOptions.push(variant.options.includes(selectedValues[option]))
      }
      return matchedOptions.reduce((result, item) => result && item, [])
    })

    return matched[0]
  }

  const getInitialSelected = (currentVariant) => {
    const values = {}
    for (const index in options) {
      const option = options[index]

      if (!values[option]) {
        values[option] = []
      }

      const value = currentVariant.options[index]
      if (!values[option].includes(value)) {
        values[option] = value
      }
    }

    return values
  }

  const setUrlParams = (variant) => {
    const urlParams = new URLSearchParams(window.location.search)
    if (!urlParams.has('variant')) {
      urlParams.append('variant', variant.id)
    } else {
      urlParams.set('variant', variant.id)
    }
    window.history.replaceState({}, null, `${window.location.pathname}?${urlParams.toString()}`)
  }

  const availableValues = (() => {
    const values = {}
    for (const index in options) {
      const option = options[index]

      if (!values[option]) {
        values[option] = []
      }

      for (const variant of variants) {
        const value = variant.options[index]
        if (!values[option].includes(value)) {
          values[option].push(value)
        }
      }
      values[option] = values[option].sort((a, b) => a.localeCompare(b))
    }
    return values
  })()

  useEffect(() => {
    const selectableOptions = getSelectableValues(availableValues, selected)
    if (selectableOptions) {
      setSelectableValues(selectableOptions)
    }
    const selectedVariant = getSelectedVariant(selected)
    if (selectedVariant) {
      updateCurrentVariant(selectedVariant)
      updateUrl && setUrlParams(selectedVariant)
      globalEmitter.emit(emitterProps.product.updateVariant, selectedVariant)
    }
  }, [selected])

  useEffect(() => {
    const selectedInit = getInitialSelected(currentVariant)
    setSelected(selectedInit)
  }, [])

  return {
    selected,
    setSelected,
    availableValues,
    selectableValues
  }
}

export default useProductVariant
